import { useState, useCallback } from "react";

type TypeSingleSelectProps<T extends string> = {
  initialValue?: T | "";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (value: string | T) => any;
};

export const useSelect = <T extends string>(
  {
    initialValue = "",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: userOnChange = () => {},
  }: TypeSingleSelectProps<T> = {
    initialValue: "",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: () => {},
  }
) => {
  const [value, setValue] = useState<string | T>(initialValue);

  const onChange = useCallback(
    (newValue: string) => {
      if (newValue !== value) {
        setValue(newValue);
        userOnChange(newValue);
      }
    },
    [userOnChange, value]
  );

  return { value, onChange };
};
